/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Module Helper
 ---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const cases = new StoreModule('cases');
const general = new StoreModule('general');

/* ----------------------------------------
    Transitions
---------------------------------------- */

import * as transition from '@router/transitions/transition';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    beforeRouteEnter (to, from, next) {
        const proceed = () => next(vm => {
            if(!vm.$options.transition || !vm.$options.transition.enter)
                return next();

            const route = [vm, to, from];

            vm.$options.transition.enter({
                el: vm.$el,
                parent: vm.$parent.$el,
                route: route
            }, transition.generic);
        });

        if(to.name === 'case') {
            const project = cases.getters('getCaseById', to.params.id);
            const animation = transition.swtich.switchCase(document.body, project.color);
            animation.then(() => proceed());
        } else if(to.name !== 'home') {
            const animation = transition.swtich.switchPage(document.body);
            animation.then(() => proceed());
        } else {
            proceed();
        }
    },
    beforeRouteUpdate (to, from, next) {
        const compare = from.fullPath.replace('#', '') === to.fullPath.replace('#', '');

        if(to.hash) return;

        if(!this.$options.transition || !this.$options.transition.update && compare)
            return next();

        const route = [to, from];

        this.$options.transition.update({
            el: this.$el,
            parent: this.$parent.$el,
            route: route
        }, transition.generic);

        if(to.name === 'case') {
            const project = cases.getters('getCaseById', to.params.id);
            const animation = transition.swtich.switchCase(document.body, project.color);
            animation.then(() => next());
        } else {
            next();
        }
    },
    beforeRouteLeave (to, from, next) {
        if(!this.$options.transition || !this.$options.transition.leave)
            return next();

        const route = [to, from];

        this.$options.transition.leave({
            el: this.$el,
            parent: this.$parent.$el,
            route: route
        }, transition.generic);

        next();
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export class TransitionMixin extends Vue {}